<div class="my-4 bg-card shadow rounded-2xl p-4">

    <fuse-alert
        class="my-4"
        *ngIf="showAlertEliminar"
        [dismissed]="!showAlertEliminar"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertEliminar.type"
        [@shake]="alertEliminar.type === 'error'">
        {{ alertEliminar.message }}
    </fuse-alert>
    <fuse-alert
        class="my-4"
        *ngIf="showAlertDescargar"
        [dismissed]="!showAlertDescargar"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertDescargar.type"
        [@shake]="alertDescargar.type === 'error'">
        {{ alertDescargar.message }}
    </fuse-alert>

    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
        <div class="text-xl">Pólizas</div>
        <button mat-raised-button color="primary"
                *ngIf="user?.rol === accountRole.master"
                (click)="abrirFormularioCarga()">
            <mat-icon class="mr-2">upload_file</mat-icon>
            Cargar póliza
        </button>
    </div>

    <!-- Tabla -->
    <div class="overflow-auto">
        <table mat-table [dataSource]="dataSource" class="w-full">

            <!-- Número de Póliza -->
            <ng-container matColumnDef="numeroPoliza">
                <th mat-header-cell *matHeaderCellDef>Número de Póliza</th>
                <td mat-cell *matCellDef="let p" class="whitespace-nowrap">{{ p.numeroPoliza }}</td>
            </ng-container>

            <!-- Aseguradora -->
            <ng-container matColumnDef="aseguradora">
                <th mat-header-cell *matHeaderCellDef>Aseguradora</th>
                <td mat-cell *matCellDef="let p" class="whitespace-nowrap">{{ p.aseguradora }}</td>
            </ng-container>

            <!-- Monto -->
            <ng-container matColumnDef="monto">
                <th mat-header-cell *matHeaderCellDef>Monto</th>
                <td mat-cell *matCellDef="let p" class="whitespace-nowrap">
                    {{ p.monto | currency:'MXN':'symbol-narrow':'1.2-2' }}
                </td>
            </ng-container>

            <!-- Inicio de Vigencia -->
            <ng-container matColumnDef="vigenciaInicio">
                <th mat-header-cell *matHeaderCellDef>Inicio de Vigencia</th>
                <td mat-cell *matCellDef="let p" class="whitespace-nowrap">{{ p.vigenciaInicio | date:'dd/MM/yyyy' }}</td>
            </ng-container>

            <!-- Fin de Vigencia -->
            <ng-container matColumnDef="vigenciaFin">
                <th mat-header-cell *matHeaderCellDef>Fin de Vigencia</th>
                <td mat-cell *matCellDef="let p" class="whitespace-nowrap">{{ p.vigenciaFin | date:'dd/MM/yyyy' }}</td>
            </ng-container>

            <!-- Pagada -->
            <ng-container matColumnDef="pagada">
                <th mat-header-cell *matHeaderCellDef>Pagada</th>
                <td mat-cell *matCellDef="let p">
                    <mat-icon [class.text-green-500]="p.pagada" [class.text-gray-400]="!p.pagada">
                        {{ p.pagada ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                </td>
            </ng-container>

            <!-- Estatus -->
            <ng-container matColumnDef="estatus">
                <th mat-header-cell *matHeaderCellDef>Estatus</th>
                <td mat-cell *matCellDef="let p" class="whitespace-nowrap">{{ p.estatus }}</td>
            </ng-container>

            <!-- Acciones -->
            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let p">
                    <button mat-icon-button
                            class="text-blue-600"
                            matTooltip="Descargar"
                            (click)="descargarPdf(p.id, p.numeroPoliza)">
                        <mat-icon>download</mat-icon>
                    </button>
                    <button mat-icon-button
                            class="text-blue-600"
                            *ngIf="user?.rol === accountRole.master"
                            matTooltip="Editar póliza"
                            (click)="editarPoliza(p)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn"
                            *ngIf="user?.rol === accountRole.master"
                            matTooltip="Eliminar póliza"
                            (click)="eliminarPoliza(p)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Estado vacío -->
            <tr class="mat-row" *matNoDataRow>
                <td [colSpan]="displayedColumns.length" class="text-center py-8 text-secondary">
                    <mat-icon class="text-4xl mb-2 opacity-30">description</mat-icon>
                    <p>No hay pólizas registradas</p>
                </td>
            </tr>
        </table>
    </div>
    <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50]"
        showFirstLastButtons>
    </mat-paginator>
</div>
